// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SideMenuAdminUsers {
    display: flex;
    gap: 20px;
}

.SideMenuAdminUsers_list {
    flex: 1;
    padding: 20px;
    overflow-y: auto;
    background-color: #f9f9f9;
    border: 1px solid #ddd;
    border-radius: 5px;
    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
    margin: 20px;
}

.SideMenuAdminUsers_sessions_panel {
    padding: 20px;
    width: 100%;
    height: auto;
    background-color: #f9f9f9;
    border: 1px solid #ddd;
    border-radius: 5px;
    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
    box-sizing: border-box;
}

.SideMenuAdminUsers_json_content {
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 80%;
    height: 80vh;
    margin-top: 0;
    padding: 20px;
    background: #fff;
    border: 1px solid #ddd;
    border-radius: 8px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
    z-index: 2001;
    overflow: auto;
}

.SideMenuAdminUsers_json_overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.5);
    z-index: 1999;
}

.SideMenuAdminUsers_json_close {
    position: absolute;
    top: 10px;
    right: 10px;
    padding: 8px;
    background: none;
    border: none;
    cursor: pointer;
    font-size: 20px;
    color: #666;
}

.SideMenuAdminUsers_session {
    padding: 10px;
    border: 1px solid #ddd;
    margin-bottom: 10px;
    border-radius: 4px;
    background: white;
}

.SideMenuAdminUsers_session_row {
    padding-right: 10px;
    justify-content: space-between;
}

.SideMenuAdminUsers_session_row > div {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    max-width: 80%;
}

.SideMenuAdminUsers_session_row strong {
    margin-right: 10px;
    flex-shrink: 0;
}

.SideMenuAdminUsers_json_button {
    padding: 8px 16px;
    background: #4CAF50;
    color: white;
    border: none;
    border-radius: 20px;
    cursor: pointer;
    margin-top: 10px;
    font-size: 14px;
    transition: background-color 0.3s;
}

.SideMenuAdminUsers_json_button:hover {
    background: #45a049;
}

.SideMenuAdminUsers_json_content {
    margin-top: 10px;
    padding: 10px;
    background: #f5f5f5;
    border: 1px solid #ddd;
    border-radius: 4px;
    white-space: pre-wrap;
    font-family: monospace;
    font-size: 12px;
    overflow-y: auto;
}

.SideMenuAdminUsers_logs_panel {
    padding: 20px;
    overflow-y: auto;
    min-height: 600px;
    width: 100%;
    background-color: #f9f9f9;
    border: 1px solid #ddd;
    border-radius: 5px;
    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
}

.SideMenuAdminUsers_log_item {
    padding: 10px;
    border-bottom: 1px solid #eee;
    margin-bottom: 10px;
}

.SideMenuAdminUsers_client_item {
    padding: 10px;
    border-bottom: 1px solid #eee;
    margin-bottom: 10px;
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.SideMenuAdminUsers_log_item_info {
    flex-grow: 1;
}

.SideMenuAdminUsers_client_session {
    margin-top: 5px;
    padding: 5px 10px;
    background: #4CAF50;
    color: white;
    border: none;
    border-radius: 4px;
    cursor: pointer;
}

.SideMenuAdminUsers_client_session:hover {
    background: #45a049;
}

.SideMenuAdminUsers_log_time {
    color: #666;
    font-size: 12px;
    margin-bottom: 5px;
}

.SideMenuAdminUsers_log_message {
    color: #333;
    font-size: 14px;
}

.SideMenuAdminUsers_item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 10px;
    border-bottom: 1px solid #eee;
    transition: background-color 0.3s; /* Плавный переход для фона */
}

.SideMenuAdminUsers_item:hover {
    background-color: #f0f0f0; /* Цвет фона при наведении */
}

.SideMenuAdminUsers_item--disabled {
    background-color: #e0e0e0;
}

.SideMenuAdminUsers_buttons {
    display: flex;
    gap: 10px;
}

.SideMenuAdminUsers_buttons button {
    padding: 5px 10px;
    border: 1px solid #ddd;
    border-radius: 4px;
    background: #4CAF50;
    color: white;
    cursor: pointer;
}

.SideMenuAdminUsers_sessions {
    margin-top: 10px;
    padding: 10px;
    background: #f5f5f5;
    border-radius: 4px;
}

.SideMenuAdminUsers_session {
    display: flex;
    justify-content: space-between;
    padding: 5px 0;
    border-bottom: 1px solid #eee;
}

.SideMenuAdminUsers_session:last-child {
    border-bottom: none;
}

.SideMenuAdminUsers_buttons button:hover {
    background: #45a049;
    cursor: pointer;
}

.SideMenuAdminUsers_buttons button:hover {
    background: #45a049;
}

.SideMenuAdminUsers_modal_overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.5);
    z-index: 1000;
}

.SideMenuAdminUsers_client_sessions_modal_overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.7);
    z-index: 2000;
}

.SideMenuAdminUsers_client_sessions_modal {
    position: fixed;
    inset: 0;
    margin: auto;
    background: white;
    padding: 20px;
    border-radius: 8px;
    width: 80%;
    height: fit-content;
    max-height: 80vh;
    overflow-y: auto;
    z-index: 2001;
}

.SideMenuAdminUsers_modal {
    position: fixed;
    inset: 0;
    margin: auto;
    background: white;
    padding: 20px;
    border-radius: 8px;
    z-index: 1001;
    width: 80%;
    height: fit-content;
    max-height: 80vh;
    overflow-y: auto;
}

.SideMenuAdminUsers_modal_close {
    position: absolute;
    top: 10px;
    right: 10px;
    background: none;
    border: none;
    font-size: 24px;
    cursor: pointer;
    color: #666;
}

.SideMenuAdminUsers_loading {
    text-align: center;
    padding: 20px;
    color: #666;
}

.SideMenuAdminUsers_no_logs {
    text-align: center;
    padding: 20px;
    color: #666;
}

.SideMenuAdminUsers_info {
    display: flex;
    align-items: center;
    gap: 10px;
    color: #333;
    font-size: 14px;
}

.SideMenuAdminUsers_avatar {
    width: 40px;
    height: 40px;
    border-radius: 50%;
    overflow: hidden;
    flex-shrink: 0;
}

.SideMenuAdminUsers_avatar img {
    width: 100%;
    height: 100%;
    object-fit: cover;
}

.SideMenuAdminUsers_text {
    display: flex;
    flex-direction: column;
    gap: 4px;
}`, "",{"version":3,"sources":["webpack://./src/pages/dashboardPage/components/sideMenu/administrator/SideMenuAdminUsers.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,SAAS;AACb;;AAEA;IACI,OAAO;IACP,aAAa;IACb,gBAAgB;IAChB,yBAAyB;IACzB,sBAAsB;IACtB,kBAAkB;IAClB,wCAAwC;IACxC,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,WAAW;IACX,YAAY;IACZ,yBAAyB;IACzB,sBAAsB;IACtB,kBAAkB;IAClB,wCAAwC;IACxC,sBAAsB;AAC1B;;AAEA;IACI,eAAe;IACf,QAAQ;IACR,SAAS;IACT,gCAAgC;IAChC,UAAU;IACV,YAAY;IACZ,aAAa;IACb,aAAa;IACb,gBAAgB;IAChB,sBAAsB;IACtB,kBAAkB;IAClB,0CAA0C;IAC1C,aAAa;IACb,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT,8BAA8B;IAC9B,aAAa;AACjB;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,YAAY;IACZ,eAAe;IACf,eAAe;IACf,WAAW;AACf;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,mBAAmB;IACnB,8BAA8B;AAClC;;AAEA;IACI,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,iBAAiB;IACjB,mBAAmB;IACnB,YAAY;IACZ,YAAY;IACZ,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,iCAAiC;AACrC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,sBAAsB;IACtB,kBAAkB;IAClB,qBAAqB;IACrB,sBAAsB;IACtB,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,gBAAgB;IAChB,iBAAiB;IACjB,WAAW;IACX,yBAAyB;IACzB,sBAAsB;IACtB,kBAAkB;IAClB,wCAAwC;AAC5C;;AAEA;IACI,aAAa;IACb,6BAA6B;IAC7B,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,6BAA6B;IAC7B,mBAAmB;IACnB,WAAW;IACX,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;AACvB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,mBAAmB;IACnB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,aAAa;IACb,6BAA6B;IAC7B,iCAAiC,EAAE,6BAA6B;AACpE;;AAEA;IACI,yBAAyB,EAAE,4BAA4B;AAC3D;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,SAAS;AACb;;AAEA;IACI,iBAAiB;IACjB,sBAAsB;IACtB,kBAAkB;IAClB,mBAAmB;IACnB,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,cAAc;IACd,6BAA6B;AACjC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT,8BAA8B;IAC9B,aAAa;AACjB;;AAEA;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT,8BAA8B;IAC9B,aAAa;AACjB;;AAEA;IACI,eAAe;IACf,QAAQ;IACR,YAAY;IACZ,iBAAiB;IACjB,aAAa;IACb,kBAAkB;IAClB,UAAU;IACV,mBAAmB;IACnB,gBAAgB;IAChB,gBAAgB;IAChB,aAAa;AACjB;;AAEA;IACI,eAAe;IACf,QAAQ;IACR,YAAY;IACZ,iBAAiB;IACjB,aAAa;IACb,kBAAkB;IAClB,aAAa;IACb,UAAU;IACV,mBAAmB;IACnB,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,gBAAgB;IAChB,YAAY;IACZ,eAAe;IACf,eAAe;IACf,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,WAAW;AACf;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;AACZ","sourcesContent":[".SideMenuAdminUsers {\n    display: flex;\n    gap: 20px;\n}\n\n.SideMenuAdminUsers_list {\n    flex: 1;\n    padding: 20px;\n    overflow-y: auto;\n    background-color: #f9f9f9;\n    border: 1px solid #ddd;\n    border-radius: 5px;\n    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);\n    margin: 20px;\n}\n\n.SideMenuAdminUsers_sessions_panel {\n    padding: 20px;\n    width: 100%;\n    height: auto;\n    background-color: #f9f9f9;\n    border: 1px solid #ddd;\n    border-radius: 5px;\n    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);\n    box-sizing: border-box;\n}\n\n.SideMenuAdminUsers_json_content {\n    position: fixed;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n    width: 80%;\n    height: 80vh;\n    margin-top: 0;\n    padding: 20px;\n    background: #fff;\n    border: 1px solid #ddd;\n    border-radius: 8px;\n    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);\n    z-index: 2001;\n    overflow: auto;\n}\n\n.SideMenuAdminUsers_json_overlay {\n    position: fixed;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    background: rgba(0, 0, 0, 0.5);\n    z-index: 1999;\n}\n\n.SideMenuAdminUsers_json_close {\n    position: absolute;\n    top: 10px;\n    right: 10px;\n    padding: 8px;\n    background: none;\n    border: none;\n    cursor: pointer;\n    font-size: 20px;\n    color: #666;\n}\n\n.SideMenuAdminUsers_session {\n    padding: 10px;\n    border: 1px solid #ddd;\n    margin-bottom: 10px;\n    border-radius: 4px;\n    background: white;\n}\n\n.SideMenuAdminUsers_session_row {\n    padding-right: 10px;\n    justify-content: space-between;\n}\n\n.SideMenuAdminUsers_session_row > div {\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    max-width: 80%;\n}\n\n.SideMenuAdminUsers_session_row strong {\n    margin-right: 10px;\n    flex-shrink: 0;\n}\n\n.SideMenuAdminUsers_json_button {\n    padding: 8px 16px;\n    background: #4CAF50;\n    color: white;\n    border: none;\n    border-radius: 20px;\n    cursor: pointer;\n    margin-top: 10px;\n    font-size: 14px;\n    transition: background-color 0.3s;\n}\n\n.SideMenuAdminUsers_json_button:hover {\n    background: #45a049;\n}\n\n.SideMenuAdminUsers_json_content {\n    margin-top: 10px;\n    padding: 10px;\n    background: #f5f5f5;\n    border: 1px solid #ddd;\n    border-radius: 4px;\n    white-space: pre-wrap;\n    font-family: monospace;\n    font-size: 12px;\n    overflow-y: auto;\n}\n\n.SideMenuAdminUsers_logs_panel {\n    padding: 20px;\n    overflow-y: auto;\n    min-height: 600px;\n    width: 100%;\n    background-color: #f9f9f9;\n    border: 1px solid #ddd;\n    border-radius: 5px;\n    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);\n}\n\n.SideMenuAdminUsers_log_item {\n    padding: 10px;\n    border-bottom: 1px solid #eee;\n    margin-bottom: 10px;\n}\n\n.SideMenuAdminUsers_client_item {\n    padding: 10px;\n    border-bottom: 1px solid #eee;\n    margin-bottom: 10px;\n    width: 100%;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n}\n\n.SideMenuAdminUsers_log_item_info {\n    flex-grow: 1;\n}\n\n.SideMenuAdminUsers_client_session {\n    margin-top: 5px;\n    padding: 5px 10px;\n    background: #4CAF50;\n    color: white;\n    border: none;\n    border-radius: 4px;\n    cursor: pointer;\n}\n\n.SideMenuAdminUsers_client_session:hover {\n    background: #45a049;\n}\n\n.SideMenuAdminUsers_log_time {\n    color: #666;\n    font-size: 12px;\n    margin-bottom: 5px;\n}\n\n.SideMenuAdminUsers_log_message {\n    color: #333;\n    font-size: 14px;\n}\n\n.SideMenuAdminUsers_item {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    padding: 10px;\n    border-bottom: 1px solid #eee;\n    transition: background-color 0.3s; /* Плавный переход для фона */\n}\n\n.SideMenuAdminUsers_item:hover {\n    background-color: #f0f0f0; /* Цвет фона при наведении */\n}\n\n.SideMenuAdminUsers_item--disabled {\n    background-color: #e0e0e0;\n}\n\n.SideMenuAdminUsers_buttons {\n    display: flex;\n    gap: 10px;\n}\n\n.SideMenuAdminUsers_buttons button {\n    padding: 5px 10px;\n    border: 1px solid #ddd;\n    border-radius: 4px;\n    background: #4CAF50;\n    color: white;\n    cursor: pointer;\n}\n\n.SideMenuAdminUsers_sessions {\n    margin-top: 10px;\n    padding: 10px;\n    background: #f5f5f5;\n    border-radius: 4px;\n}\n\n.SideMenuAdminUsers_session {\n    display: flex;\n    justify-content: space-between;\n    padding: 5px 0;\n    border-bottom: 1px solid #eee;\n}\n\n.SideMenuAdminUsers_session:last-child {\n    border-bottom: none;\n}\n\n.SideMenuAdminUsers_buttons button:hover {\n    background: #45a049;\n    cursor: pointer;\n}\n\n.SideMenuAdminUsers_buttons button:hover {\n    background: #45a049;\n}\n\n.SideMenuAdminUsers_modal_overlay {\n    position: fixed;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    background: rgba(0, 0, 0, 0.5);\n    z-index: 1000;\n}\n\n.SideMenuAdminUsers_client_sessions_modal_overlay {\n    position: fixed;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    background: rgba(0, 0, 0, 0.7);\n    z-index: 2000;\n}\n\n.SideMenuAdminUsers_client_sessions_modal {\n    position: fixed;\n    inset: 0;\n    margin: auto;\n    background: white;\n    padding: 20px;\n    border-radius: 8px;\n    width: 80%;\n    height: fit-content;\n    max-height: 80vh;\n    overflow-y: auto;\n    z-index: 2001;\n}\n\n.SideMenuAdminUsers_modal {\n    position: fixed;\n    inset: 0;\n    margin: auto;\n    background: white;\n    padding: 20px;\n    border-radius: 8px;\n    z-index: 1001;\n    width: 80%;\n    height: fit-content;\n    max-height: 80vh;\n    overflow-y: auto;\n}\n\n.SideMenuAdminUsers_modal_close {\n    position: absolute;\n    top: 10px;\n    right: 10px;\n    background: none;\n    border: none;\n    font-size: 24px;\n    cursor: pointer;\n    color: #666;\n}\n\n.SideMenuAdminUsers_loading {\n    text-align: center;\n    padding: 20px;\n    color: #666;\n}\n\n.SideMenuAdminUsers_no_logs {\n    text-align: center;\n    padding: 20px;\n    color: #666;\n}\n\n.SideMenuAdminUsers_info {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n    color: #333;\n    font-size: 14px;\n}\n\n.SideMenuAdminUsers_avatar {\n    width: 40px;\n    height: 40px;\n    border-radius: 50%;\n    overflow: hidden;\n    flex-shrink: 0;\n}\n\n.SideMenuAdminUsers_avatar img {\n    width: 100%;\n    height: 100%;\n    object-fit: cover;\n}\n\n.SideMenuAdminUsers_text {\n    display: flex;\n    flex-direction: column;\n    gap: 4px;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
